const isMobileDevice = () => {
  const agent = window.navigator.userAgent;

  return !!(
    agent.match(/(tablet|ipad)|(android(?!.*mobile))/i) || agent.match(/Mobile/)
  );
};

export default isMobileDevice;
